import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutotextService } from '../autotext.service';
import { ExamsService } from '../exams.service';
import { PregnancyService } from '../pregnancy.service';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-medicalhistory',
    templateUrl: './medicalhistory.component.html',
    styleUrls: ['./medicalhistory.component.scss'],
    standalone: false
})
export class MedicalhistoryComponent implements OnInit {
  @Input('isWeightAss') isWeightAss;
  @Input('typeOfUser') typeOfUser;
  showHistory = false;
  aiSummaryLoading = false;
  @Output() newItemEvent = new EventEmitter<boolean>();
  constructor(
    public ps:PregnancyService, public es:ExamsService, public atS: AutotextService,
    public ls: LoginService, private patService: PatientsService
  ) { }

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.ps.pregForm.get('Remarks');
          const existing = (control.value || '').toString().trim();
          const previous = (res.previousSummary || '').toString().trim();
          // Replace only our own previously-pasted AI block (exact match), so a
          // doctor's hand-typed notes are never overwritten; otherwise append.
          if (previous && existing === previous) {
            control.setValue(res.summary);
          } else {
            control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

  ngOnInit() {
    if(this.es.ExamType == 'Fetal Echo'){
      this.showHistory =true;
      this.newItemEvent.emit(this.showHistory)
    }
  }
  setShowHistory(){
    this.showHistory = !this.showHistory
    this.newItemEvent.emit(this.showHistory);
  }

}
